module.exports = __webpack_public_path__ + "img/101.5f0b84ae.png";